export const customUSDCSymbol = ["USDC", "USDC.e"];

export const defaulUSDCSymbol = "USDC";
